import * as i0 from '@angular/core';
import { forwardRef, Component, ViewEncapsulation, Input, HostBinding, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class NgSwitcheryComponent {
    constructor() {
        // Allow the input to be disabled, and when it is make it somewhat transparent.
        this.disabled = false;
        // the method set in registerOnChange to emit changes back to the form
        this.propagateChange = (_) => { };
    }
    get opacity() {
        return this.disabled ? 0.25 : 1;
    }
    // Allows Angular to update the model
    // Update the model and changes needed for the view here.
    writeValue(value) {
        this.value = value;
    }
    // Allows Angular to register a function to call when the model changes.
    // Save the function as a property to call later here.
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // Allows Angular to register a function to call when the input has been touched.
    // Save the function as a property to call later here.
    registerOnTouched() { }
    // Change event from Switchery Toggle
    onChange() {
        this.value = !this.value;
        // update the form
        this.propagateChange(this.value);
    }
    // Allows Angular to disable the input.
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
NgSwitcheryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.7", ngImport: i0, type: NgSwitcheryComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NgSwitcheryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.7", type: NgSwitcheryComponent, selector: "ng-switchery", inputs: { value: "value", onLabel: "onLabel", offLabel: "offLabel", color: "color", size: "size", sticked: "sticked", customClasses: "customClasses", disabled: "disabled" }, host: { properties: { "style.opacity": "this.opacity" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NgSwitcheryComponent),
            multi: true,
        },
    ], ngImport: i0, template: ` <div
    class="checkbox {{ customClasses }}"
    [ngClass]="{
      disabled: disabled,
      'checkbox-double': offLabel && offLabel.length > 0,
      'checkbox-right': sticked
    }"
  >
    <label>
      {{ offLabel }}
      <input
        type="checkbox"
        class="switchery"
        [disabled]="disabled"
        [value]="value"
        (change)="onChange()"
        [checked]="value"
      />
      <span class="switchery {{ color }} {{ size }}"> <small></small> </span>
      {{ onLabel }}
    </label>
  </div>`, isInline: true, styles: [".checkbox{display:block;position:relative;margin-bottom:10px}.checkbox input{display:none}.checkbox label{padding-left:0}.switchery{border:1px solid #ddd;border-radius:100px;cursor:pointer;display:inline-block;width:44px;position:relative;box-sizing:content-box;vertical-align:middle}.switchery,.switchery>small{background-color:#fff;height:22px}input+.switchery{background-color:#fff;border-color:#dfdfdf;box-shadow:#dfdfdf 0 0 inset;transition:border .4s,box-shadow .4s;margin-right:7px}input:checked+.switchery{background-color:#2196f3;border-color:#2196f3;box-shadow:#2196f3 0 0 0 12px inset;transition:border .4s,box-shadow .4s,background-color 1.2s}.checkbox-double .switchery{position:relative;margin-left:7px;margin-right:7px}.switchery>small{background-color:#fff;border-radius:100px;width:22px;height:22px;position:absolute;left:0;top:0;box-shadow:0 1px 3px #0006;transition:background-color .4s,left .2s}input:checked+.switchery>small{left:22px;transition:background-color .4s,left .2s;background-color:#fff}input:checked+.switchery.switchery-lg>small{left:26px}.switchery.switchery-lg{margin-top:-4px;height:26px;width:52px}.switchery-lg small{height:26px;width:26px}input:checked+.switchery.switchery-sm>small{left:18px}.switchery.switchery-sm{margin-top:0;height:18px;width:36px}.switchery-sm small{height:18px;width:18px}input:checked+.switchery.switchery-xs>small{left:14px}.switchery.switchery-xs{margin-top:2px;height:14px;width:28px}.switchery-xs small{height:14px;width:14px}.disabled .switchery{cursor:not-allowed;opacity:.5}input:checked+.switchery-primary{background-color:#2196f3;border-color:#2196f3;box-shadow:#2196f3 0 0 0 12px inset;transition:border .4s,box-shadow .4s,background-color 1.2s}input:checked+.switchery-info{background-color:#00bcd4;border-color:#00bcd4;box-shadow:#00bcd4 0 0 0 12px inset;transition:border .4s,box-shadow .4s,background-color 1.2s}input:checked+.switchery-success{background-color:#64bd63;border-color:#64bd63;box-shadow:#64bd63 0 0 0 12px inset;transition:border .4s,box-shadow .4s,background-color 1.2s}input:checked+.switchery-warning{background-color:#ff7043;border-color:#ff7043;box-shadow:#ff7043 0 0 0 12px inset;transition:border .4s,box-shadow .4s,background-color 1.2s}input:checked+.switchery-danger{background-color:#ef5350;border-color:#ef5350;box-shadow:#ef5350 0 0 0 12px inset;transition:border .4s,box-shadow .4s,background-color 1.2s}.checkbox.checkbox-right label{display:flex;align-items:center}.checkbox.checkbox-right .switchery{position:absolute;left:auto;right:0}\n"], directives: [{ type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.7", ngImport: i0, type: NgSwitcheryComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "ng-switchery",
                    template: ` <div
    class="checkbox {{ customClasses }}"
    [ngClass]="{
      disabled: disabled,
      'checkbox-double': offLabel && offLabel.length > 0,
      'checkbox-right': sticked
    }"
  >
    <label>
      {{ offLabel }}
      <input
        type="checkbox"
        class="switchery"
        [disabled]="disabled"
        [value]="value"
        (change)="onChange()"
        [checked]="value"
      />
      <span class="switchery {{ color }} {{ size }}"> <small></small> </span>
      {{ onLabel }}
    </label>
  </div>`,
                    styleUrls: ["./ng-switchery-ios.component.css"],
                    encapsulation: ViewEncapsulation.None,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => NgSwitcheryComponent),
                            multi: true,
                        },
                    ],
                }]
        }], propDecorators: { value: [{
                type: Input
            }], onLabel: [{
                type: Input
            }], offLabel: [{
                type: Input
            }], color: [{
                type: Input
            }], size: [{
                type: Input
            }], sticked: [{
                type: Input
            }], customClasses: [{
                type: Input
            }], disabled: [{
                type: Input
            }], opacity: [{
                type: HostBinding,
                args: ["style.opacity"]
            }] } });

class NgSwitcheryModule {
}
NgSwitcheryModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.7", ngImport: i0, type: NgSwitcheryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgSwitcheryModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.7", ngImport: i0, type: NgSwitcheryModule, declarations: [NgSwitcheryComponent], imports: [FormsModule, CommonModule], exports: [NgSwitcheryComponent] });
NgSwitcheryModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.7", ngImport: i0, type: NgSwitcheryModule, imports: [[FormsModule, CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.7", ngImport: i0, type: NgSwitcheryModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NgSwitcheryComponent],
                    imports: [FormsModule, CommonModule],
                    exports: [NgSwitcheryComponent],
                }]
        }] });

/*
 * Public API Surface of angular-switchery-ios
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgSwitcheryComponent, NgSwitcheryModule };
